import { NgModule } from '@angular/core';
import { PipelineFiltersService } from './pipeline-filters.service';
import { PipelineMultiSelectModule } from '../pipeline-multi-select/pipeline-multi-select.module';
import { StatusSelectModule } from '../status-select/status-select.module';
import { SalesTeamMultiSelectModule } from '../salesteam-multi-select/sales-team-multi-select.module';
import { TagMultiSelectModule } from '../tag-selector/tag-multi-selector.module';
import { DateFiltersModule } from '../date-filters/date-filters.module';
import { SalespersonMultiSelectModule } from '../salesperson-multi-select/salesperson-multi-select.module';
import { PipelineFilterPackageSelectorModule } from '../package-selector/pipeline-filter-package-selector.module';
import { ProductSelectorModule } from '../product-selector/product-selector.module';

@NgModule({
  imports: [
    PipelineMultiSelectModule,
    StatusSelectModule,
    TagMultiSelectModule,
    SalesTeamMultiSelectModule,
    DateFiltersModule,
    SalespersonMultiSelectModule,
    PipelineFilterPackageSelectorModule,
    ProductSelectorModule,
  ],
  providers: [PipelineFiltersService],
})
export class PipelineFiltersServiceModule {}
